import { useAuth } from '@/context/AuthContext';

export type ViewKey = 'notes' | 'knowledge';

interface SidebarProps {
  active: ViewKey;
  onChange: (view: ViewKey) => void;
  onOpenTelegramSettings: () => void;
  onLogout: () => void;
}

const navItems: { key: ViewKey; label: string; icon: string }[] = [
  { key: 'notes', label: 'Ghi chú', icon: 'ri-sticky-note-line' },
  { key: 'knowledge', label: 'Kiến thức', icon: 'ri-lightbulb-line' },
];

export default function Sidebar({
  active,
  onChange,
  onOpenTelegramSettings,
  onLogout,
}: SidebarProps) {
  const { user } = useAuth();

  return (
    <aside className="flex h-full w-60 shrink-0 flex-col border-r border-background-200 bg-background-100">
      <div className="flex items-center gap-2.5 px-5 py-5">
        <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
          <i className="ri-book-2-line text-lg" />
        </div>
        <div>
          <p className="font-heading text-sm font-semibold text-foreground-950">
            Note System
          </p>
        </div>
      </div>

      <nav className="flex-1 space-y-1 px-3 py-2">
        {navItems.map((item) => (
          <button
            key={item.key}
            type="button"
            onClick={() => onChange(item.key)}
            className={`flex w-full items-center gap-3 whitespace-nowrap rounded-lg px-3 py-2.5 text-sm font-medium transition ${
              active === item.key
                ? 'bg-primary-100 text-primary-800'
                : 'text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
            }`}
          >
            <span className="flex h-5 w-5 items-center justify-center">
              <i className={`${item.icon} text-lg`} />
            </span>
            {item.label}
          </button>
        ))}
      </nav>

      <div className="border-t border-background-200 px-3 py-3">
        <button
          type="button"
          onClick={onOpenTelegramSettings}
          className="flex w-full items-center gap-3 whitespace-nowrap rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-600 transition hover:bg-background-200 hover:text-foreground-900"
        >
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-send-plane-2-line text-lg" />
          </span>
          Cảnh báo Telegram
        </button>
        <button
          type="button"
          onClick={onLogout}
          className="flex w-full items-center gap-3 whitespace-nowrap rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-600 transition hover:bg-background-200 hover:text-foreground-900"
        >
          <span className="flex h-5 w-5 items-center justify-center">
            <i className="ri-logout-box-r-line text-lg" />
          </span>
          Đăng xuất
        </button>

        <div className="mt-3 flex items-center gap-2.5 rounded-lg bg-background-200/70 px-3 py-2.5">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-background-50 text-sm font-semibold">
            {user?.email?.charAt(0).toUpperCase() ?? 'A'}
          </div>
          <div className="min-w-0">
            <p className="truncate text-xs font-medium text-foreground-800">
              {user?.email ?? 'admin'}
            </p>
            <p className="text-[11px] text-foreground-400">Quản trị viên</p>
          </div>
        </div>
      </div>
    </aside>
  );
}